import React, { useRef, useState } from 'react';
import { useCreateUserWithEmailAndPassword, useSendEmailVerification, useUpdateProfile } from 'react-firebase-hooks/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase.init';

const RegisterScreen = () => {
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const confirmPasswordRef = useRef(null);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const [
    createUserWithEmailAndPassword,
    user,
    loading,
    error
  ] = useCreateUserWithEmailAndPassword(auth);
  const [sendEmailVerification] = useSendEmailVerification(auth);
  const [updateProfile, updating] = useUpdateProfile(auth);
  const register = async (e) => {
    e.preventDefault();
    const email = emailRef.current.value;
    const password = passwordRef.current.value;
    const name = nameRef.current.value;
    const confirmPassword = confirmPasswordRef.current.value;
    console.log('hello');
    if (password.length >= 6) {
      if (password === confirmPassword) {
        await createUserWithEmailAndPassword(email, password);
        await updateProfile({ displayName: name });
        await sendEmailVerification();

      } else {
        setMessage("Passwords didn't match!");
      }
    } else {
      setMessage('Password length should be at least 6!');
    }
  };

  //   if(loading){
  //     return <Loading></Loading>
  // }
  if (user) {
    navigate('/home');
  }
  console.log(user);
  return (
    <div className="registerScreen">
      <div className="loginScreen__background">
        <img
          className="loginScreen__logo"
          src="https://i.ibb.co/7bWX0YV/Acq.png"
          alt=""
        />
        <button onClick={() => navigate('/signin')} className="loginScreen__button">
          Sign In
        </button>
        <div className="loginScreen__gradient" />
      </div>
      <div className="registerScreen__body">
        <div className="signupScreen">
          <form>
            <h1 className=''>Sign Up</h1>
            <input ref={nameRef} placeholder="Name" type="name" />
            <input ref={emailRef} placeholder="Email" type="email" />
            <input ref={passwordRef} placeholder="Password" type="password" />
            <input ref={confirmPasswordRef} placeholder="Confirm Password" type="password" />
            <button type="submit" onClick={register}>
              Sign In
            </button>

            <h4>
              <span className="signupScreen__gray">Already have an account? </span>
              <span className="signupScreen__link" onClick={() => navigate('/signin')}>
                Sign In
              </span>
            </h4>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterScreen;